import baseUrl from "@/api/baseUrl";
import user from "@/api/user/index";
import { Dialog } from "vant";
import auth from "@/store/auth";
import global from "@/store/global";
import Vue from "vue";
import router from "@/router";
var discon_count = 0; // 记录重连次数
Vue.use(Dialog);
export default {
  // 实现websocket的连接，需要携带参数token
  STAFF_WEBSOCKET({ state, commit, dispatch, getters }, loadingText = '正在建立连接，请稍后...') {
    // let wsuri = `wss://mtu.plus/wss/`;
    // console.log('socket start baseUrl', baseUrl.baseurl);
    let baseTrim = baseUrl.getUrl().replace(/^http(s)?:\/\//, "")
    if (baseTrim === 'www.mtu.plus') {
      baseTrim = "mtu.plus"
    }
    let wsuri = `wss://${baseTrim}/wss/`;
    if (getters.STAFF_UPDATE && getters.STAFF_UPDATE.close) {
      console.log('socket重新连接');
      getters.STAFF_UPDATE.close();
    }
    commit('global/setLoading', {
      flag: true,
      title: loadingText
    }, { root: true });
    commit("STAFF_UPDATEWEBSOCKET", new WebSocket(wsuri));
    // 只有定义了onopen方法，才能继续实现接收消息，即在使用的地方调用onmessage方法。
    getters.STAFF_UPDATE.onopen = function () {
      console.log("socket 开启成功");
      commit("setWebsocketState", true);
      commit('global/setLoading', {
        flag: false,
        title: ''
      }, { root: true });
    };
    getters.STAFF_UPDATE.onmessage = function (evt) {
      // console.log("evt", evt);
      let message = JSON.parse(evt.data);
      console.log("store websocket receive a message", message);
      const { data, type } = message;
      switch (type) {
        case "ping":
          getters.STAFF_UPDATE.send(JSON.stringify({ type: "pong" }));
          break;
        case "hello":
          console.log("page action clientid", data.clientid);
          if (auth.state.userinfo.wstoken) {
            user.switchClienId({
              params: { type: "web", old: state.clienId, new: data.clientid },
              loadingText: "正在切换clientId",
              errorFn: this.handleError
            });
            commit("STAFF_UPDATECLIENID", data.clientid);
          }
          break;
      }
    };
    getters.STAFF_UPDATE.onclose = function (data) {
      console.log("ws断开连接 socket data====>", data.code);
      console.log("ws断开连接 socket is connect====>", state.isConnect);
      commit("setWebsocketState", false);
      if(data.code !== 10000) {
        if(discon_count > 5) {
          commit('global/setLoading', {
            flag: false
          }, { root: true });
          Dialog.alert({
            title: "断开连接",
            message: "多次建立连接失败，请检查网络是否可用，若网络可用仍然连接失败请联系网站管理员"
          }).then(() => {
            discon_count = 0
            commit("CLEAR_STORAGE", {}, { root: true });
            router.go(0)
          });
        } else {
          discon_count++;
          setTimeout(() => {
            dispatch('STAFF_WEBSOCKET')
          }, 2000)
        }
      }
    };
  },
  STAFF_CLOSE_WEBSOCKET({ state, commit, dispatch, getters }) {
    console.log('close websocket', getters.STAFF_UPDATE);
    if (getters.STAFF_UPDATE) {
      getters.STAFF_UPDATE.close();
    }
  }
};
